import React from 'react';
import PropTypes from 'prop-types';

import BaseContractModal from '../../BaseContractModal';
import ReonboardingContractModalContent from './ReonboardingContractModalContent';

const ReonboardingContractModal = ({
  user,
  coachId,
  showModal,
  onClose,
  isAmendment,
  contractId,
  productId,
}) => (
  <BaseContractModal
    showModal={showModal}
    onClose={onClose}
  >
    <ReonboardingContractModalContent
      user={user}
      coachId={coachId}
      onClose={onClose}
      isAmendment={isAmendment}
      contractId={contractId}
      productId={productId}
    />
  </BaseContractModal>
);

ReonboardingContractModal.propTypes = {
  user: PropTypes.object.isRequired,
  coachId: PropTypes.string.isRequired,
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isAmendment: PropTypes.bool.isRequired,
  // Becomes the amendment's `originalContract`. Empty for a re-onboard, which supersedes nothing.
  contractId: PropTypes.string,
  productId: PropTypes.string,
};

ReonboardingContractModal.defaultProps = {
  contractId: '',
  productId: '',
};

export default ReonboardingContractModal;
